import React, { useEffect, useState } from "react";
import {
  FaChalkboardUser,
  FaLocationDot,
  FaSchool,
  FaSpinner,
} from "react-icons/fa6";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import {
  cleanMatric,
  getClassDetailsDirect,
  getFreeTeachers,
  showSwal,
  updateClass,
} from "../../AppManager";
import { LiaTimesCircle } from "react-icons/lia";

function EditClass() {
  const { record, setRecord, setPreventRefetch } = useOutletContext();
  const [classDetails, setClassDetails] = useState({
    name: "",
    teacher: "",
    assistant: "",
    location: "",
  });
  const navigate = useNavigate();
  const { Class } = useParams();
  const [formData, setFormData] = useState({
    newname: "",
    teacher: "",
    assistant: "",
    location: "",
  });
  const [status, setStatus] = useState({ status: "", type: "", message: "" });
  const [uploading, setUploading] = useState(false);
  const [teachers, setTeachers] = useState([]);

  useEffect(() => {
    setPreventRefetch(true);
  });

  useEffect(() => {
    getFreeTeachers()
      .then((data) => setTeachers(data))
      .catch((err) => err);
  }, []);

  useEffect(() => {
    getClassDetailsDirect(Class)
      .then((cdetail) => {
        if (cdetail.name !== "") {
          setClassDetails(cdetail);
        } else {
          showSwal("error", "Class not Found");
          navigate("/admin/overview/editclass", { replace: true });
        }
      })
      .catch((err) => {
        showSwal("error", "Class not Found");
        navigate("/admin/overview/editclass", { replace: true });
      });
  }, [Class, record, navigate]);

  useEffect(() => {
    setFormData((oldFormData) => {
      return {
        ...oldFormData,
        name: classDetails.name,
        teacher: classDetails["teacher matric"] ?? "",
        assistant: classDetails["assistant matric"] ?? "",
        location: classDetails.location,
      };
    });
  }, [classDetails]);

  document.title = "Edit Class";

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData((oldFormData) => {
      return {
        ...oldFormData,
        [name]:
          name === "teacher" || name === "assistant"
            ? cleanMatric(value)
            : value,
      };
    });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      if (
        formData.teacher !== classDetails.teacher ||
        formData["assistant"] !== classDetails["assistant"] ||
        formData.location !== ""
      ) {
        setStatus({ status: "", type: "", message: "" });
        setUploading(true);

        const newClass = {
          ...classDetails,
          ...formData,
        };

        const res = await updateClass(formData);
        if (res === "Updated") {
          setRecord((oldRecord) => {
            let updatedClass = [
              ...oldRecord[classDetails.centre][classDetails.trainingClass]
                .classes,
            ];
            for (let k = 0; k < updatedClass.length; k++) {
              const Class = updatedClass[k];
              if (Class.name === classDetails.name) {
                updatedClass[k] = newClass;
              }
            }

            const newRecord = {
              ...oldRecord,
              [classDetails.centre]: {
                ...oldRecord[classDetails.centre],
                [classDetails.trainingClass]: {
                  ...oldRecord[classDetails.centre][classDetails.trainingClass],
                  classes: updatedClass,
                },
              },
            };

            return newRecord;
          });
          setStatus({
            status: "success",
            type: "success",
            message: "Updated Successfully. Redirecting...",
          });
          setTimeout(() => {
            navigate(`/admin/overview/classes/${Class}`, { replace: true });
          }, 2000);
        } else if (res === "Not Found") {
          setStatus({
            status: "not found",
            type: "failed",
            message: "Class not Found. Redirecting...",
          });
          setTimeout(() => {
            navigate("/admin/overview/editclass", { replace: true });
          }, 2000);
        } else if (res === "Name") {
          setStatus({
            status: "name",
            type: "failed",
            message: "New Name already exists",
          });
          setUploading(false);
        } else if (res === "NTeacher") {
          setStatus({
            status: "Teacher",
            type: "failed",
            message: "Teacher not Found",
          });
          setUploading(false);
        } else if (res === "Teacher") {
          setStatus({
            status: "Teacher",
            type: "failed",
            message: "Teacher already assigned to a Class",
          });
          setUploading(false);
        } else if (res === "NAssistant") {
          setStatus({
            status: "Assistant",
            type: "failed",
            message: "Assistant not Found",
          });
          setUploading(false);
        } else if (res === "Assistant") {
          setStatus({
            status: "Assistant",
            type: "failed",
            message: "Assistant already assigned to a Class",
          });
          setUploading(false);
        } else {
          setStatus({
            status: "failed",
            type: "failed",
            message: "Update Failed",
          });
          setUploading(false);
        }
      }
    } catch (error) {
      setStatus({ status: "failed", type: "failed", message: "Update Failed" });
      setUploading(false);
    }
  }

  useEffect(() => {
    if (status.message !== "") {
      document
        .getElementById("status-wrapper")
        .scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [status]);

  return (
    <div className="formwrapper" style={{ margin: "50px 0" }}>
      <div className="wrapper">
        <div className="form-box login">
          <h2>Edit Class</h2>
          <form onSubmit={handleSubmit}>
            {status.message !== "" && (
              <p className="status-wrapper" id="status-wrapper">
                <span className={`status-message ${status.type}`}>
                  {status.message}
                </span>
                <LiaTimesCircle
                  className="status-close"
                  onClick={() => {
                    setStatus({ status: "", type: "", message: "" });
                  }}
                />
              </p>
            )}
            <div className="input-box">
              <input
                type="text"
                value={classDetails.name}
                autoComplete="off"
                required
                readOnly
                placeholder=" "
              />
              <label>Current Name</label>
            </div>
            <div className="input-box">
              <span className="icon">
                <FaSchool />
              </span>
              <input
                readOnly={uploading}
                type="text"
                onChange={handleChange}
                value={formData.newname}
                autoComplete="off"
                pattern="[A-Za-z()\- ]+"
                name="newname"
                placeholder=" "
                minLength={10}
                maxLength={50}
              />
              <label>New Name</label>
            </div>
            <div className="input-box">
              <select
                disabled={uploading}
                name="teacher"
                value={formData.teacher}
                onChange={handleChange}
                className="inputs"
              >
                <option value="">None Assigned</option>
                {classDetails["teacher matric"] && (
                  <option value={classDetails["teacher matric"]}>
                    {classDetails["teacher"]} - {classDetails["teacher matric"]}
                  </option>
                )}
                {teachers.map((teacher) => (
                  <option
                    value={teacher["matric"]}
                    key={teacher["matric"] + " teacher"}
                  >
                    {teacher["name"]} - {teacher["matric"]}
                  </option>
                ))}
              </select>
              <label>
                <FaChalkboardUser /> Teacher
              </label>
            </div>
            <div className="input-box">
              <select
                disabled={uploading}
                name="assistant"
                value={formData.assistant}
                onChange={handleChange}
                className="inputs"
              >
                <option value="">None Assigned</option>
                {classDetails["assistant matric"] && (
                  <option value={classDetails["assistant matric"]}>
                    {classDetails["assistant"]} -{" "}
                    {classDetails["assistant matric"]}
                  </option>
                )}
                {teachers.map((teacher) => (
                  <option
                    value={teacher["matric"]}
                    key={teacher["matric"] + " assistant"}
                  >
                    {teacher["name"]} - {teacher["matric"]}
                  </option>
                ))}
              </select>
              <label>
                <FaChalkboardUser /> Assistant Teacher
              </label>
            </div>
            <div className="input-box">
              <span className="icon">
                <FaLocationDot />
              </span>
              <input
                readOnly={uploading}
                type="text"
                onChange={handleChange}
                value={formData.location}
                autoComplete="off"
                pattern="[A-Za-z0-9\- ]+"
                name="location"
                placeholder=" "
                minLength={3}
                maxLength={50}
              />
              <label>Location</label>
            </div>
            <button type="submit" disabled={uploading} className="btn">
              {uploading ? <FaSpinner className="spinner" /> : "Update"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EditClass;
